module.exports = __webpack_public_path__ + "hinted-OpenSans-Semibold.765a9b280e0426759ba1.ttf";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-OpenSans-Semibold.ttf
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-OpenSans-Semibold.ttf
// module chunks = 1